import { useState, useEffect, useCallback, useRef } from "react";
import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";
import { UserEpic, UserEpicFromJSON } from "../bitmaker/schemas/Users/UserEpic";

export const useUserEpics = (login?: string) => {
  const [epics, setEpics] = useState<UserEpic[]>([]);
  const [loadingUserEpics, setLoadingUserEpics] = useState(false);
  const [fetchUserEpicsError, setFetchUserEpicsError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchUserEpics = useCallback(() => {
    if (!isMountedRef.current || !login) return;

    setLoadingUserEpics(true);
    setFetchUserEpicsError(null);

    BitmakerAPIClient.get(`/users/${login}/epics`, null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching user epics:", message);
        setFetchUserEpicsError("Error fetching user epics. Please try again.");
        setLoadingUserEpics(false);
        return;
      }

      const data = Array.isArray(response.data) ? response.data : [];
      setEpics(data.map(UserEpicFromJSON));

      setLoadingUserEpics(false);
    });
  }, [login, handleAPIError]);

  useEffect(() => {
    fetchUserEpics();
  }, [fetchUserEpics]);

  return {
    epics,
    loadingUserEpics,
    fetchUserEpicsError,
    refetchUserEpics: fetchUserEpics,
  };
};
